import { IntegrationConfig } from 'modules/Integrations/domain'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import logo from './rilletLogo.svg'
import { RilletIntegrationDetail } from './RilletIntegrationDetail/RilletIntegrationDetail'
import { RilletConfigurationManagement } from './RilletConfigurationManagement/RilletConfigurationManagement'
import { rilletConfigurationLoader } from './rillet.loader'
import { rilletConfigurationMutator } from './rillet.mutator'

export const rilletIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/rillet',
  title: 'Rillet',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: false
  },
  description:
    'Sync Sequence invoices in real-time and streamline your accounting process.',
  components: {
    detail: RilletIntegrationDetail,
    management: RilletConfigurationManagement
  },
  communication: {
    configuration: {
      loader: rilletConfigurationLoader,
      mutator: rilletConfigurationMutator
    }
  }
}

export type RilletIntegrationConfig = {
  apiKey?: string
  maskedApiKey: string
  webhookSecret?: string
  maskedWebhookSecret?: string
  /** Push unlinked customers to Rillet when an invoice is finalised or sent. */
  autoLinkCustomers: boolean
  /** Resolved sync permission for the auto-link toggle (read-only, for the paused state). */
  autoLinkSyncPermission?: Dashboardv99990101Api.GetEntityTypeSyncToggles.SyncPermission
}
